import React, { useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import MyMultilineField from "../forms/MyMultilineField";
import MySelectField from "../forms/MySelectField";
import MyMultiSelectField from "../forms/MyMultiSelectField";
import MyTextField from "../forms/MyTextField";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import AxiosInstance from "../Axios";
import { fetchVariableValues } from "../../Extractor";
import colors from "../constants/Colors";

const Create = () => {
  const navigate = useNavigate();
  const project_id = localStorage.getItem("project_id");

  const defaultValues = {
    description: "",
    status: "",
    link: "",
    activity: "",
    reportingPeriod: "",
    audiences: "",
    estimation: "",
  };

  const schema = yup.object({
    description: yup.string(),
    status: yup.string().required("Social Media is a required field"),
    link: yup.string(),
    activity: yup.string().required("The type of activity is required"),
    reportingPeriod: yup
      .string()
      .required("Reporting Period is a required field"),
    audiences: yup
      .array()
      .of(yup.string())
      .min(1, "At least one type of audience is required")
      .required("The type of audience is required"),
    estimation: yup
      .number()
      .typeError("Estimation must be a number")
      .required("the estimation is required"),
  });

  const { handleSubmit, control } = useForm({
    defaultValues,
    resolver: yupResolver(schema),
  });

  const [audienceOptions, setAudienceOptions] = useState([]);
  const [reportingPeriodOptions, setReportingPeriodOptions] = useState([]);
  const [typeActivityOptions, setTypeActivityOptions] = useState([]);
  const [socialMediaOptions, setSocialMediaOptions] = useState([]);

  useEffect(() => {
    const getOptions = async () => {
      const { values: audienceValues } = await fetchVariableValues("Audiences");
      setAudienceOptions(audienceValues.map((v) => v.name));

      const { values: reportingPeriodValues } = await fetchVariableValues(
        "Reporting Period"
      );
      setReportingPeriodOptions(reportingPeriodValues.map((v) => v.name));

      const { values: typeActivityValues } = await fetchVariableValues(
        "Type of Activities"
      );
      setTypeActivityOptions(typeActivityValues.map((v) => v.name));

      const { values: socialMediaValues } = await fetchVariableValues(
        "Social Media"
      );
      setSocialMediaOptions(socialMediaValues.map((v) => v.name));

      console.log("yo", audienceValues);
    };

    getOptions();
  }, []);

  const submission = (data) => {
    console.log(data);
    AxiosInstance.post(`projects/${project_id}/socialmedia/`, {
      description: data.description,
      status: data.status,
      link: data.link,
      activity: data.activity,
      reportingPeriod: data.reportingPeriod,
      audiences: data.audiences,
      estimation: Math.round(data.estimation / data.audiences.length),
    }).then((res) => {
      navigate(`/`);
    });
  };
  const sortedReportingPeriodOptions = reportingPeriodOptions.sort((a, b) =>
    a.localeCompare(b)
  );
  return (
    <div>
      <form onSubmit={handleSubmit(submission)}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            backgroundColor: colors.secondary,
            marginBottom: "10px",
            borderTopRightRadius: 5,
            borderTopLeftRadius: 5,
          }}
        >
          <Typography sx={{ marginLeft: "20px", color: "#fff" }}>
            Add a social activity
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            width: "100%",
            boxShadow: 3,
            padding: 4,
            flexDirection: "column",
            marginTop: -1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-around",
              marginBottom: "40px",
            }}
          >
            <MySelectField
              label={
                <span>
                  Social Media<span style={{ color: "red" }}> *</span>
                </span>
              } // label="Social Media"
              name="status"
              control={control}
              width={"30%"}
              options={socialMediaOptions}
            />

            <MySelectField
              label={
                <span>
                  Type of Activities<span style={{ color: "red" }}> *</span>
                </span>
              }
              //label="Type of Activities"
              name="activity"
              control={control}
              width={"30%"}
              options={typeActivityOptions}
            />

            <MyMultilineField
              label="Description"
              name="description"
              // placeholder="Provide a description"
              control={control}
              width={"30%"}
              marginTop={15}
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-around",
              marginBottom: "40px",
            }}
          >
            <MyMultilineField
              label="Link"
              name="link"
              control={control}
              width={"30%"}
            />

            <MySelectField
              label={
                <span>
                  Reporting Period<span style={{ color: "red" }}> *</span>
                </span>
              }
              //label="Reporting Period"
              name="reportingPeriod"
              control={control}
              width={"30%"}
              options={sortedReportingPeriodOptions}
            />

            <MyMultiSelectField
              label={
                <span>
                  Type of audience<span style={{ color: "red" }}> *</span>
                </span>
              }
              //label="Type of audience"
              name="audiences"
              control={control}
              width={"30%"}
              options={audienceOptions}
            />
          </Box>

          <Box sx={{ display: "flex", justifyContent: "space-around" }}>
            <MyTextField
              label="Estimation people"
              name="estimation"
              placeholder="Reached audiences"
              control={control}
              width={"30%"}
            />

            <Box sx={{ width: "30%" }}>
              <Button
                variant="contained"
                type="submit"
                sx={{ width: "100%", backgroundColor: colors.secondary }}
              >
                Submit
              </Button>
              <Button
                variant="contained"
                onClick={() => navigate("/")}
                sx={{ width: "100%", backgroundColor: colors.secondary, mt: 2 }}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Box>
      </form>
    </div>
  );
};

export default Create;
